<template>
  <b-container class="mb-4">
      <b-card>
        <b-row>
            <b-col>
                <b-form @submit.prevent="update()">
                    <b-row>
                        <b-col>
                            <b-form-group label="Nombre">
                                <b-form-input v-model="form.name" type="text"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Ciudad">
                                <b-form-input v-model="form.city" type="text"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="País">
                                <b-form-input v-model="form.country" type="text"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Fecha">
                                <b-form-input v-model="form.date" type="date"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col>
                            <b-form-checkbox v-model="form.visible" name="check-button" switch inline>
                                Visible
                            </b-form-checkbox>
                        </b-col>
                    </b-row>

                    <b-button type="submit" variant="primary">Actualizar Competición</b-button>
                    <b-button @click="cancel" variant="none" class="iq-bg-danger ml-3">Cancelar</b-button>
                </b-form>
            </b-col>
        </b-row>
      </b-card>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'EditarCompetición',
  data () {
    return {
      form: {
        name: '',
        city: '',
        country: '',
        date: '',
        visible: true
      }
    }
  },
  methods: {
    update () {
      const date = new Date(this.form.date.split("-"))
      this.form.date = date
      axios.put(`https://us-central1-atpro-app.cloudfunctions.net/api/competitions/update/${this.$router.currentRoute.params.id}`, this.form)
        .then(r => {
          // console.log('Competitions updated!', r.data.data, this.form)
          this.$router.push({ name: 'atpro.competitions' })
        })
        .catch(e => {
          console.error('Error competitions', e)
        })
    },
    cancel () {
      this.$router.push({ name: 'atpro.competitions' })
    }
  },
  mounted () {
    core.index()
    if (this.$router.currentRoute.params.id) {
      axios.get(`https://us-central1-atpro-app.cloudfunctions.net/api/competitions/bykey/${this.$router.currentRoute.params.id}`)
        .then(r => {
          // console.log('Current competitions data', r.data.data)
          try {
            this.form = r.data.data.item
            const date = moment(this.form.date._seconds * 1000).format('YYYY-MM-DD')
            this.form.date = date
          } catch (error) {
            console.error("Error parsing competition data", error)
          }
        })
    } else {
      this.$router.push({ name: 'atpro.competitions' })
    }
  }
}
</script>
